import { render, staticRenderFns } from "./BindAgentMessageDialog.vue?vue&type=template&id=c33e1828&scoped=true"
import script from "./BindAgentMessageDialog.vue?vue&type=script&lang=js"
export * from "./BindAgentMessageDialog.vue?vue&type=script&lang=js"
import style0 from "./BindAgentMessageDialog.vue?vue&type=style&index=0&id=c33e1828&prod&lang=scss&scoped=true"
import style1 from "./BindAgentMessageDialog.vue?vue&type=style&index=1&id=c33e1828&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33e1828",
  null
  
)

export default component.exports